import { NgModule } from '@angular/core';

import { FloorPipe } from './floor.pipe';
import { CeilPipe } from './ceil.pipe';
import { SimNaoPipe } from './yes-no.pipe';
import { DateFormatPipe } from './date-pt.pipe';
import { SafePipe } from './safe.pipe';
import { SafeHtmlPipe } from './safe.html.pipe';



@NgModule({
    declarations: [ FloorPipe, CeilPipe, SimNaoPipe,DateFormatPipe,SafePipe,SafeHtmlPipe ],
    exports: [ FloorPipe,CeilPipe, SimNaoPipe,DateFormatPipe,SafePipe,SafeHtmlPipe],
    providers:[SimNaoPipe,SafePipe,SafeHtmlPipe]
})
export class PipesModule {

}
